

























































































































import { Component, Vue } from "vue-property-decorator";
import guestTopBar from "../components/guestTopBar.vue";
import PasswordInput from "../components/forms/PasswordInput.vue";
import SSO from "./sso.vue";
import consts from "../consts";
import axios from "axios";

@Component({
  components: {
    guestTopBar,
    PasswordInput,
    SSO
  }
})
export default class Invite extends Vue {
  private inviteData: any | null = null;
  private name: string = "";
  private password: string = "";
  private passwordValid: boolean = false;
  private inputType: string = "password";
  private focused: boolean = false;
  private token: string = "";
  private errorMessage: string = "";
  private showDismissibleAlert: boolean = false;
  private creatingAccount: boolean = false;
  private error: boolean = false;
  private useSSO: boolean = false;

  private created() {
    this.token = this.$route.params.inviteID;
    this.getInviteData(this.token);
  }

  private mounted() {
    if (this.token && !this.inviteData.AcceptedOn) {
      localStorage.invitetoken = this.token;
    }
  }

  private getInviteData(token: string) {
    axios
      .get(consts.serverURL + "team/invite/" + token + "/details")
      .then(resp => {
        console.log("INVITE", resp.data);
        this.inviteData = resp.data;
      })
      .catch(reason => {
        console.log(reason, reason.response);
        this.error = true;
      });
  }

  private validateForm() {
    return (
      this.inviteData &&
      this.inviteData.Email &&
      this.name.length > 0 &&
      this.passwordValid
    );
  }

  private acceptInvite() {
    let token = this.$route.params.inviteID;

    axios({
      method: "POST",
      url: consts.serverURL + "team/invite/" + token + "/accept"
    })
      .then(resp => {
        this.getInviteData(this.token);
      })
      .catch(reason => {
        this.errorMessage = reason.response;
        console.log(reason, reason.response);
      });
  }

  private createAccount() {
    let data: any = {};
    if (this.validateForm()) {
      this.creatingAccount = true;
      data.email = this.inviteData.Email;
      data.password = this.password;
      data.name = this.name;

      axios({
        method: "POST",
        url: consts.serverURL + "signup/email",
        data: data
      })
        .then(resp => {
          this.getInviteData(this.token);
          this.creatingAccount = false;
        })
        .catch(reason => {
          this.errorMessage = reason.response;
          console.log(reason, reason.response);
        });
    }
  }
}
